import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';

import PrintProductSize from './PrintProductSize';
import { getPrintProductQuery } from '../../../../../../../../../../temp/views/memberships/AlbumMembershipGroup/graphql/queries/getPrintProductQuery';
import NativeActivityIndicator from '../../../../../../../../../../../components/global/NativeActivityIndicator';

const propTypes = {
  className: PropTypes.string,
  printProduct: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    sizes: PropTypes.shape({
      records: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          print_size: PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
          }).isRequired,
        }).isRequired,
      ).isRequired,
    }).isRequired,
  }),
  onPrintProductSizeSelect: PropTypes.func.isRequired,
  getPrintProductSizePrice: PropTypes.func,
  getCartItem: PropTypes.func,
  prePaid: PropTypes.bool,
};

const PrintProductSizes = ({
  className,
  printProduct,
  onPrintProductSizeSelect,
  getPrintProductSizePrice,
  getCartItem,
  prePaid,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  if (!printProduct) {
    return (
      <div className="text-center py-3">
        <NativeActivityIndicator />
      </div>
    );
  }

  const printProductSizes = printProduct.sizes.records;

  return (
    <div className={classes}>
      {printProductSizes.map(printProductSize => {
        return (
          <PrintProductSize
            key={printProductSize.id}
            prePaid={prePaid}
            printProduct={printProduct}
            printProductSize={printProductSize}
            onPrintProductSizeSelect={onPrintProductSizeSelect}
            getPrintProductSizePrice={getPrintProductSizePrice}
            isInCart={getCartItem?.({
              printProductId: printProduct.id,
              printProductSizeId: printProductSize.id,
              prePaid,
            })}
          />
        );
      })}
    </div>
  );
};

PrintProductSizes.propTypes = propTypes;

export { PrintProductSizes as PrintProductSizesComponent };

const withPrintProduct = graphql(getPrintProductQuery, {
  options: ({ printProductId }) => ({
    variables: {
      id: printProductId,
    },
  }),
  props: ({ data: { printProducts } = {} }) => ({
    printProduct: printProducts?.records?.[0],
  }),
  skip: ({ printProductId }) => !printProductId,
});

export default compose(withPrintProduct)(PrintProductSizes);
